<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="center center">
    <p>Setze eine Bild-Beschreibung</p>

    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center">
      <mat-form-field>
        <textarea
          matInput
          placeholder="Beschreibe hier dein Bild."
          formControlName="description"
          [maxlength]="maxlength"
        >
        </textarea>
      </mat-form-field>

      <mat-error *ngIf="form.controls.description.touched && form.controls.description.errors" class="invalid-feedback">
        <div *ngIf="form.controls.description.errors">
          {{ messages.invalImageDescriptionLength }}
        </div>
      </mat-error>
    </form>

    <p>
      <button class="gray-button" (click)="closeDialog()">Abbrechen</button>
      <button class="orange-button" (click)="save()">Speichern</button>
    </p>
  </div>
</mat-dialog-content>
